// A neutral 9:16 placeholder image. Assigning it to a <video poster> OVERRIDES the
// black default Android WebView poster (the "black circle" / play glyph drawn before
// a frame is decoded). Used app-wide so every video preview looks intentional, never
// broken. Zero imports on purpose (safe to import from FileUpload without a cycle).
export const NEUTRAL_POSTER =
  "data:image/svg+xml;charset=utf-8," +
  encodeURIComponent(
    "<svg xmlns='http://www.w3.org/2000/svg' width='90' height='160'>" +
    "<rect width='90' height='160' fill='#141a2b'/></svg>"
  );

// Resolve the best <video poster> for a media URL:
//  1) an explicit poster (already-resolved URL) when the caller has one,
//  2) the Cloudflare Stream thumbnail derived from an HLS manifest URL,
//  3) the neutral brand poster → guarantees we NEVER show Android's black circle.
// `resolvedMediaUrl` must already be run through resolveMediaUrl(); explicit too.
export function videoPosterFor(resolvedMediaUrl, explicitPoster) {
  if (explicitPoster) return explicitPoster;
  if (resolvedMediaUrl && resolvedMediaUrl.includes("cloudflarestream.com")) {
    return resolvedMediaUrl.replace(/\/manifest\/video\.m3u8.*$/, "/thumbnails/thumbnail.jpg");
  }
  // Bunny Stream HLS: https://{cdn}/{guid}/playlist.m3u8 -> https://{cdn}/{guid}/thumbnail.jpg
  if (resolvedMediaUrl && resolvedMediaUrl.includes(".m3u8")) {
    return resolvedMediaUrl.replace(/\/[^/]*\.m3u8.*$/, "/thumbnail.jpg");
  }
  return NEUTRAL_POSTER;
}

// <img onError>: a poster that 404s (or a Cloudflare thumbnail refused with 400) must
// NEVER show the browser's broken-image « ? » glyph — swap in the neutral plate instead.
export function onPosterError(e) {
  const img = e?.currentTarget;
  if (img && img.src !== NEUTRAL_POSTER) img.src = NEUTRAL_POSTER;
}
